var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09322 8.78442L6.29358 6.58407C6.74243 6.13522 6.89774 5.47202 6.7162 4.86377C6.57425 4.38814 6.41432 3.81637 6.30801 3.32743C6.20969 2.87522 5.81288 2.5 5.3501 2.5H4.09322C3.16767 2.5 2.40759 3.2532 2.50912 4.17317C3.28091 11.1663 8.83367 16.7191 15.8268 17.4909C16.7468 17.5924 17.5 16.8323 17.5 15.9068V14.6499C17.5 14.1872 17.1233 13.8075 16.6679 13.7247C16.1657 13.6333 15.6343 13.4837 15.1897 13.3419C14.5509 13.1382 13.8409 13.2814 13.3669 13.7554L11.2156 15.9068",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.62847ebc02e86ee87d37c7a7ed4bbcc5.svg";
export { ForwardRef as ReactComponent };